import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationHasUsersError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationHasUsersError'),
  organizationId: z.string(),
  userIds: z.array(z.string()),
});

export type OrganizationHasUsersError = z.infer<
  typeof OrganizationHasUsersError
>;
